"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classes = exports.ButtonIconPositions = exports.ButtonSizes = exports.ButtonTypes = void 0;

var _types, _sizes, _iconPositions;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ButtonTypes = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary'
};
exports.ButtonTypes = ButtonTypes;
var ButtonSizes = {
  "default": 'default',
  small: 'small',
  full: 'full'
};
exports.ButtonSizes = ButtonSizes;
var ButtonIconPositions = {
  "default": 'default',
  iconOnly: 'icon_only',
  iconLeft: 'icon_left'
};
exports.ButtonIconPositions = ButtonIconPositions;
var __baseClass = 'luna-button';
var classes = {
  base: __baseClass,
  disabled: "".concat(__baseClass, "-disabled"),
  types: (_types = {}, _defineProperty(_types, ButtonTypes.primary, "".concat(__baseClass, "-primary")), _defineProperty(_types, ButtonTypes.secondary, "".concat(__baseClass, "-secondary")), _defineProperty(_types, ButtonTypes.tertiary, "".concat(__baseClass, "-tertiary")), _types),
  sizes: (_sizes = {}, _defineProperty(_sizes, ButtonSizes.small, "".concat(__baseClass, "-small")), _defineProperty(_sizes, ButtonSizes.full, "".concat(__baseClass, "-full_width")), _sizes),
  iconPositions: (_iconPositions = {}, _defineProperty(_iconPositions, ButtonIconPositions.iconOnly, "".concat(__baseClass, "-icon_only")), _defineProperty(_iconPositions, ButtonIconPositions.iconLeft, "".concat(__baseClass, "-icon_left")), _iconPositions)
};
exports.classes = classes;
